import React, { useMemo } from 'react';

import {
  Step1,
  Step2,
  Step3,
  Step4,
} from 'assets/exports/imageExport';
import TutorialCard from './TutorialCard';

import Styles from './index.module.css';

const cards = [
  {
    title: '前往付款連結     >',
    img: Step1,
  },
  {
    title: '選擇儲值方案     >',
    img: Step2,
  },
  {
    title: '填入購買資訊     >',
    img: Step3,
  },
  {
    title: '轉帳完成付款',
    img: Step4,
  },
];

function TutorialDashboard() {
  const renderCards = useMemo(() => cards.map(({ title, img }) => (
    <div
      key={title}
      className={Styles.cardItem}
    >
      <TutorialCard title={title} img={img} />
    </div>
  )));

  return (
    <div
      className={Styles.container}
    >
      {renderCards}
    </div>
  );
}

export default TutorialDashboard;
